"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = exports.isTrackingDisabled = exports.isDebugMode = void 0;
const isParamInUrl = (paramName) => {
    try {
        if (typeof window !== 'undefined') {
            return new URLSearchParams(window.location.search.substr(1)).get(paramName);
        }
    }
    catch (_a) {
        return null;
    }
    return null;
};
const isDebugMode = () => isParamInUrl("d_fa" /* QueryParam.Debug */) === 'true';
exports.isDebugMode = isDebugMode;
const isTrackingDisabled = () => isParamInUrl("notrack_fa" /* QueryParam.NoTracking */) === 'true';
exports.isTrackingDisabled = isTrackingDisabled;
exports.debug = typeof window !== 'undefined' && (0, exports.isDebugMode)()
    ? Object.assign((appName, message) => {
        console.log(`\x1B[47;30m ${appName} \x1B[m`, message !== undefined ? message : '');
    }, {
        table: (data, ...optionalParams) => {
            console.table(data, ...optionalParams);
        },
    })
    : Object.assign(() => { }, { table: () => { } });
//# sourceMappingURL=debugging.js.map